module.exports = __webpack_public_path__ + "static/image 1-93518b67d9b9da30d350c3e920c726fc.png";